<app-doc-viewer title="Overlay" subtitle="Geo">
  <app-example-viewer codeFolder="geo/overlay">
    <igo-map-browser [map]="map" [view]="view">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>
  </app-example-viewer>
</app-doc-viewer>
